import React from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { Col } from 'react-flexbox-grid'
import gql from 'graphql-tag'

import { FormRow, FormCol } from 'style/styled'
import { DateTimePicker, Select, Form } from 'components/forms'
import Divider from 'components/Divider'
import Button from 'components/Button'
import { ContentBlock } from 'components/ContentBlock'
import { getOrderTypeExportOptions } from 'sections/options/sections/GlobalCashRegisters/pages/ERP/orderTypeExportOptions'


const listShopsQuery = gql`
	query listShops {
		cashAssist {
			listShops {
				items {
					id
					name
					cashRegisters {
						id
					}
				}
				hasNextPage
			}
		}
	}
`

const Filter = ({ handleSetFilter }) => {
	const [t] = useTranslation()
	const initialValues = {
		date: moment().utc().startOf('day').toISOString(),

		cashRegisterIds: [],
		shop: null,
		orderTypeId: null
	}
	const dateLabel = t('statistic_section.strings.date')

	const handleSubmit = ({ shop, ...rest }) => {
		handleSetFilter({
			...rest,
			cashRegisterIds: shop.cashRegisters.map(({ id }) => id)
		})
	}

	return (
		<ContentBlock blockId='0' startExpanded={!!'called'} label={t('common.strings.settings')}>
			<Form initialValues={initialValues} onSubmit={handleSubmit}>
				<FormRow>
					<FormCol>
						<DateTimePicker
							field='date'
							label={dateLabel}
						/>
						<Select
							field='shop'
							label={t('common.strings.branch')}
							valueField='id'
							labelField='name'
							isSearchable
							simpleValue={false}
							validateOnChange
							validate={val => !val ? t('validators.required') : null}
							remoteOptions={{
								query: listShopsQuery,
								fetchPolicy: 'cache-first'
							}}
						/>
						<Select
							field='orderTypeId'
							label={t('options_section.strings.order_type')}
							options={getOrderTypeExportOptions(t)}
							isClearable
							simpleValue
						/>
					</FormCol>
				</FormRow>
				<Divider />
				<Col type='row'>
					<Button text={t('common.buttons.calculate')} type='submit' />
				</Col>
			</Form>
		</ContentBlock>
	)
}

export default Filter
